import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';

export default function initSentry(app) {
    if (process.env.NODE_ENV !== 'production') return;
    Sentry.init({
        app,
        dsn: 'https://9f47464115bd10e863cd3f380c981272@o4507571527090176.ingest.de.sentry.io/4507574099247184',
        integrations: [new BrowserTracing({})],
        ignoreErrors: ['VK is not defined', "Can't find variable: VK", 'NavigationDuplicated'],
    });
}
